import React from 'react';
import { Field, change } from 'redux-form';

import { Input, InputWithIcon, AutoCompleteSelect } from '../../../../../../itrust_common/components/form';
import { useCurrentTypeHook } from '../../../../../../itrust_common/components/others/helperHooks/useCurrentTypeHook';

import DiscountField from '../../DiscountField';
import { connect } from 'react-redux';

let Addon = props => {
  const { fields, pprops, orderStoreId, taxSettings } = props;
  const currency = useCurrentTypeHook();

  const getStoreIdForSearch = () => {
    let StoreId = localStorage.getItem('StoreID')
    if (!StoreId && StoreId == null) {
      return orderStoreId
    }
    return StoreId
  }

  return (
    <div className="row mx-0 mb-7 bg-light border-top border-top-2">
      <div className="col-12 p-5 pt-6">
        <div className="d-flex align-items-center justify-content-between">
          <h6 className="d-inline-flex align-items-center mb-0">
            Add-on Details
          </h6>
          <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => { fields.push({}); setTimeout(() => pprops.submit(), 500) }}>
            Add New
          </button>
        </div>
      </div>
      <div className="col-12 p-5">
        <div className="overview-table border rounded border-2">
          <table className="table table-hover shadow-none">
             <thead className="text-dark border-bottom bg-light border-bottom-2">
              <tr>
                <th scope="col" className="w-25">Add-on</th>
                <th scope="col">Unit Price</th>
                <th scope="col">Copay</th>
                <th scope="col">Discount</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              {fields.map((member, index, members) => (
                [<tr className="text-dark bg-light ">
                  <td className='pr-0'>
                    <Field 
                      name={`${member}[settings_eyeglass_addon_id]`} 
                      displayName={`${member}[addon_name]`} 
                      component={AutoCompleteSelect} 
                      onChangeHook={(data) => {pprops.dispatch(change('orderEyeglassForm', `${member}[settings_eyeglass_addon_id]`, data.id)); setTimeout(() => pprops.submit(), 1000) } }
                      klass="Settings::EyeglassAddon"
                      additionalFilters={{ store_inventory: getStoreIdForSearch() }}
                      textField="name" 
                      valueField="id" 
                      placeholder="Placeholder" 
                      className="form-control"
                      wrapperClasses="addon-col-width"
                    />
                  </td>
                  <td className='px-0'>
                    <Field name={`${member}[unit_price]`} component={InputWithIcon} title={currency.symbol} className="form-control" type="number" onBlur={() => setTimeout(() => pprops.submit(), 500)} />
                  </td>
                  <td className='pr-0'>
                    <Field name={`${member}[copay]`} component={InputWithIcon} title={currency.symbol} className="form-control" onBlur={() => setTimeout(() => pprops.submit(), 500)} />
                  </td>
                  <td>
                    <DiscountField
                      cashName={`${member}[cash_discount]`}
                      percentageName={`${member}[percentage_discount]`}
                      discountTypeName={`${member}[discount_type]`}
                      defaultType={members.get(index).discount_type ?? 'cash'}
                      onBlur={() => setTimeout(() => pprops.submit(), 500)}
                    />
                  </td>
                  <td>
                    <span className="badge badge-pill badge-danger"
                      onClick={() => { pprops.dispatch(change('orderEyeglassForm', `${member}[_destroy]`, true)); setTimeout(() => pprops.submit(), 1000) }}>
                      <i className="la la-trash"/>
                    </span>
                  </td>
                </tr>,
                <tr className="text-dark bg-light border-bottom">
                  <td colSpan={(members.get(index)?.tax_percentage !== undefined && members.get(index)?.tax_percentage !== null) ? "3" : "5"}>
                    <Field name={`${member}[details]`} component={Input} className="form-control" placeholder="Details" />
                  </td>
                  {((members.get(index)?.tax_percentage !== undefined && members.get(index)?.tax_percentage !== null)) && (
                    <td colSpan="2">
                      <div className="d-flex align-items-center">
                        <div>
                        <label className="mr-2 mb-0">Tax</label>
                        <Field
                          name={`${member}[tax_percentage]`}
                          type="number"
                          component="input"
                          className="form-control mr-1"
                          style={{ width: '60px' }}
                          disabled={!taxSettings.allow_item_tax_override}
                          onBlur={() => setTimeout(() => pprops.submit(), 500)}
                          />
                          </div>
                       <span className="mr-2 mt-7">%</span>
                        <div>
                         <span>Tax amount</span>
                        <input
                          type="text"
                          className="form-control disabled bg-light"
                          style={{ width: '80px' }}
                          value={members.get(index)?.tax_amount !== undefined && members.get(index)?.tax_amount !== null ? parseFloat(members.get(index).tax_amount).toFixed(2) : ''}
                          readOnly
                          />
                      </div>
                          </div>
                    </td>
                  )}
                  <td></td>
                </tr>]
              ))}
            </tbody>
          </table>
       </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  const { order: { order }, storeSetting } = state
  return {
    orderStoreId: order.store_id,
    taxSettings: storeSetting?.filtered_store_settings?.tax_settings?.[0]?.store_config || {},
  }
}

export default connect(mapStateToProps)(Addon);